<template>
  <div class="w-full">
    <div class="bg-white rounded-2xl px-6">
      <!-- Filters -->
      <div class="w-full flex flex-col gap-3">
        <div class="flex flex-col md:flex-row flex-wrap justify-between w-full">
          <h2 class="text-xl font-semibold text-gray-800">Total (Lead)</h2>

          <!-- {{ months }} {{ values }} -->

          <div class="flex flex-col md:flex-row flex-wrap gap-4">
            <!-- Dropdown Button -->
            <div class="relative inline-block">
              <select
                v-model="selectedOption"
                @change="handleDateSelection"
                class="appearance-none flex items-center px-4 py-2 border border-gray-300 rounded-full text-sm text-gray-700 bg-white hover:bg-gray-50 pr-8 w-full"
              >
                <option value="" disabled>Select Days</option>
                <option
                  v-for="option in monthfilters"
                  :key="option.label"
                  :value="option"
                >
                  {{ option.label }}
                </option>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-2 flex items-center"
              >
                <svg
                  class="w-4 h-4 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            <!-- custom start date end date -->
            <div v-if="showCustomPicker" class="flex flex-wrap  gap-5 items-center">
              <!-- <input
                type="date"
                v-model="customStart"
                class="border p-1.5 rounded"
              /> -->

              <div class="flex flex-col relative">
                <label
                  for="selected_date"
                  class="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm"
                >
                  Start Date:
                </label>
                <input
                  type="date"
                  class="px-3 py-2 text-sm border font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-full shadow-md focus:outline-none w-full"
                  v-model="customStart"
                />
              </div>
              <span>to</span>
              <!-- <input
                type="date"
                v-model="customEnd"
                class="border p-1.5 rounded"
              /> -->
              <div class="flex flex-col relative">
                <label
                  for="selected_date"
                  class="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm"
                >
                  End Date:
                </label>
                <input
                  type="date"
                  class="px-3 py-2 text-sm border font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-full shadow-md focus:outline-none w-full"
                  v-model="customEnd"
                />
              </div>
              <button
                @click="fetchCustomDate"
                class="ml-2 px-4 py-1 bg-blue-500 text-white rounded"
              >
                Go
              </button>
            </div>

            <a
              :href="downloads.download_link"
              class="flex items-center px-4 py-2 border border-gray-300 rounded-full text-sm text-gray-700 bg-white hover:bg-gray-50"
            >
              Export Data
              <svg
                class="ml-2 w-4 h-4 text-gray-500"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 4v16h16V4H4zm8 4v8m0 0l-4-4m4 4l4-4"
                />
              </svg>
            </a>
          </div>
        </div>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-6 p-6 bg-white"
        >
          <!-- Staff -->
          <div class="">
            <p class="text-sm text-gray-600">Instructor</p>
            <p class="text-xl font-semibold">
              <span
                v-if="
                  this.lead_counts.instructor_monthly_count &&
                  lead_counts.instructor_monthly_count.length
                "
              >
                {{
                  this.lead_counts.instructor_monthly_count[
                    lead_counts.instructor_monthly_count.length - 1
                  ].count
                }}</span
              >
              <span v-else>0</span>
            </p>
            <span
              class="mt-1 px-3 py-0.5 rounded-full bg-green-500 text-white text-xs"
              >+25%</span
            >
          </div>

          <!-- Student -->
          <div class="">
            <p class="text-sm text-gray-600">Student</p>
            <p class="text-xl font-semibold">
              <span
                v-if="
                  this.lead_counts.student_monthly_count &&
                  lead_counts.student_monthly_count.length
                "
              >
                {{
                  lead_counts.student_monthly_count[
                    lead_counts.student_monthly_count.length - 1
                  ].count
                }}</span
              >
              <span v-else>0</span>
            </p>
            <span
              class="mt-1 px-3 py-0.5 rounded-full bg-green-500 text-white text-xs"
              >+32%</span
            >
          </div>

          <!-- Hod -->
          <div class="">
            <p class="text-sm text-gray-600">Hod</p>
            <p class="text-xl font-semibold">
              <span
                v-if="
                  this.lead_counts.hod_monthly_count &&
                  lead_counts.hod_monthly_count.length
                "
              >
                {{
                  this.lead_counts.hod_monthly_count[
                    lead_counts.hod_monthly_count.length - 1
                  ].count
                }}
              </span>
              <span v-else>0</span>
            </p>
            <span
              class="mt-1 px-3 py-0.5 rounded-full bg-green-500 text-white text-xs"
              >+25%</span
            >
          </div>

          <!-- Coordinate -->
          <div class="">
            <p class="text-sm text-gray-600">Coordinater</p>
            <p class="text-xl font-semibold">
              <span
                v-if="
                  this.lead_counts.co_ordinate_monthly_count &&
                  lead_counts.co_ordinate_monthly_count.length
                "
              >
                {{
                  this.lead_counts.co_ordinate_monthly_count[
                    lead_counts.co_ordinate_monthly_count.length - 1
                  ].count
                }}</span
              >
              <span v-else>0</span>
            </p>
            <span
              class="mt-1 px-3 py-0.5 rounded-full bg-green-500 text-white text-xs"
              >+32%</span
            >
          </div>

          <!-- Avg. Admission -->
          <!-- <div class="">
            <p class="text-sm text-gray-600">Avg. Admission</p>
            <p class="text-xl font-semibold">
              <span v-if="this.lead_counts.avg_admission">{{
                this.lead_counts.avg_admission
              }}</span>
              <span v-else>0</span>
            </p>
            <span
              class="mt-1 px-3 py-0.5 rounded-full bg-red-500 text-white text-xs"
              >-13%</span
            >
          </div> -->

          <!-- Avg. Result -->
          <!-- <div class="">
            <p class="text-sm text-gray-600">Avg. Result</p>
            <p class="text-xl font-semibold">
              <span v-if="this.lead_counts.avg_count">{{
                this.lead_counts.avg_count
              }}</span>
              <span v-else>0</span>
            </p>
            <span
              class="mt-1 px-3 py-0.5 rounded-full bg-green-500 text-white text-xs"
              >+13%</span
            >
          </div> -->
        </div>
      </div>

      <!-- Chart -->
      <apexchart
        type="area"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: { apexchart: VueApexCharts },
  data() {
    return {
      lead_counts: [],
      downloads: "",
      months: [],
      // values: [],
      studentValues: [],
      instructorValues: [],
      coOrdinateValues: [],
      hodValues: [],

      selectedOption: "",
      monthfilters: [
        { label: "Today", days: 0 },
        { label: "Last 7 days", days: 7 },
        { label: "Last 30 days", days: 30 },
        { label: "Custom", isCustom: true },
      ],

      dateRange: [new Date(), new Date()],
      series: [],
      chartOptions: {},
      showCustomPicker: false,
      customStart: null,
      customEnd: null,
    };
  },

  computed: {
    ...mapGetters(["isAuthenticated", "userInfo"]),
  },
  mounted() {
    this.setupChart();
  },

  created() {
    this.getLeads();
    this.getDownload();
  },

  methods: {
    getLeads() {
      axios
        .get(
          `${process.env.VUE_APP_API}/total-leads/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.lead_counts = response.data.data;

            this.months = [];
            this.studentValues = [];
            this.instructorValues = [];
            this.coOrdinateValues = [];
            this.hodValues = [];

            const student = response.data.data.student_monthly_count;
            const instructor = response.data.data.instructor_monthly_count;
            const coOrdinate = response.data.data.co_ordinate_monthly_count;
            const hod = response.data.data.hod_monthly_count;

            const allMonthsSet = new Set([
              ...student.map((e) => e.month),
              ...instructor.map((e) => e.month),
              ...coOrdinate.map((e) => e.month),
              ...hod.map((e) => e.month),
            ]);
            this.months = Array.from(allMonthsSet).sort();

            const mapDataToMonths = (data) => {
              const monthMap = Object.fromEntries(
                data.map((e) => [e.month, e.count])
              );
              return this.months.map((month) => monthMap[month] || 0);
            };

            this.studentValues = mapDataToMonths(student);
            this.instructorValues = mapDataToMonths(instructor);
            this.coOrdinateValues = mapDataToMonths(coOrdinate);
            this.hodValues = mapDataToMonths(hod);

            this.setupChart();
          } else {
            console.log("Something went wrong.");
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    },

    getDownload() {
      axios
        .get(
          `${process.env.VUE_APP_API}/lead-count-csv-download/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.downloads = response.data.data;
          } else {
            console.log("something went wrong.");
          }
        });
    },

    setupChart() {
      this.series = [
        {
          name: "Student",
          data: this.studentValues,
        },
        {
          name: "Instructor",
          data: this.instructorValues,
        },
        {
          name: "HOD",
          data: this.hodValues,
        },
        {
          name: "Co-ordinate",
          data: this.coOrdinateValues,
        },
      ];

      this.chartOptions = {
        chart: {
          height: 300,
          type: "area",
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        xaxis: {
          categories: this.months,
        },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth" },
        tooltip: {
          enabled: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let value = series[seriesIndex][dataPointIndex];
            let category = w.globals.labels[dataPointIndex];

            return `
              <div style="
                background: white;
                padding: 10px;
                border-radius: 8px;
                box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
                text-align: center;
              ">
                <div style="color: #999; font-size: 12px;">This Month</div>
                <div style="font-size: 20px; font-weight: bold; color: #333;">${value}</div>
                <div style="color: #666; font-size: 14px;">${category}</div>
              </div>
            `;
          },
        },
      };
    },
    handleDateSelection() {
      if (this.selectedOption.isCustom) {
        this.showCustomPicker = true;
      } else {
        this.showCustomPicker = false;
        this.selectDate();
      }
    },
    // async selectDate() {
    //   console.log("asdfsdfsd");
    //   if (!this.selectedOption) return;

    //   const endDate = new Date();
    //   const startDate = new Date();
    //   startDate.setDate(endDate.getDate() - this.selectedOption.days);

    //   const start = startDate.toISOString().split("T")[0];
    //   const end = endDate.toISOString().split("T")[0];

    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/total-leads/?start_date=${start}&end_date=${end}&Key=${this.userInfo.token_key}`
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.lead_counts = response.data.data;

    //         this.months = [];
    //         this.studentValues = [];
    //         this.instructorValues = [];
    //         this.coOrdinateValues = [];
    //         this.hodValues = [];

    //         const student = response.data.data.student_monthly_count;
    //         const instructor = response.data.data.instructor_monthly_count;
    //         const coOrdinate = response.data.data.co_ordinate_monthly_count;
    //         const hod = response.data.data.hod_monthly_count;

    //         const allMonthsSet = new Set([
    //           ...student.map((e) => e.month),
    //           ...instructor.map((e) => e.month),
    //           ...coOrdinate.map((e) => e.month),
    //           ...hod.map((e) => e.month),
    //         ]);
    //         this.months = Array.from(allMonthsSet).sort();

    //         const mapDataToMonths = (data) => {
    //           const monthMap = Object.fromEntries(
    //             data.map((e) => [e.month, e.count])
    //           );
    //           return this.months.map((month) => monthMap[month] || 0);
    //         };

    //         this.studentValues = mapDataToMonths(student);
    //         this.instructorValues = mapDataToMonths(instructor);
    //         this.coOrdinateValues = mapDataToMonths(coOrdinate);
    //         this.hodValues = mapDataToMonths(hod);

    //         this.setupChart();
    //       } else {
    //         console.log("Something went wrong.");
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("API Error:", error);
    //     });
    // },
    async selectDate() {
      if (!this.selectedOption || this.selectedOption.isCustom) return;

      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - this.selectedOption.days);

      const start = startDate.toISOString().split("T")[0];
      const end = endDate.toISOString().split("T")[0];

      await this.fetchLeads(start, end);
    },
    async fetchCustomDate() {
      if (!this.customStart || !this.customEnd) {
        alert("Please select both start and end dates.");
        return;
      }

      await this.fetchLeads(this.customStart, this.customEnd);
    },

    async fetchLeads(start, end) {
      axios
        .get(
          `${process.env.VUE_APP_API}/total-leads/?start_date=${start}&end_date=${end}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.lead_counts = response.data.data;

            this.months = [];
            this.studentValues = [];
            this.instructorValues = [];
            this.coOrdinateValues = [];
            this.hodValues = [];

            const student = response.data.data.student_monthly_count;
            const instructor = response.data.data.instructor_monthly_count;
            const coOrdinate = response.data.data.co_ordinate_monthly_count;
            const hod = response.data.data.hod_monthly_count;

            const allMonthsSet = new Set([
              ...student.map((e) => e.month),
              ...instructor.map((e) => e.month),
              ...coOrdinate.map((e) => e.month),
              ...hod.map((e) => e.month),
            ]);
            this.months = Array.from(allMonthsSet).sort();

            const mapDataToMonths = (data) => {
              const monthMap = Object.fromEntries(
                data.map((e) => [e.month, e.count])
              );
              return this.months.map((month) => monthMap[month] || 0);
            };

            this.studentValues = mapDataToMonths(student);
            this.instructorValues = mapDataToMonths(instructor);
            this.coOrdinateValues = mapDataToMonths(coOrdinate);
            this.hodValues = mapDataToMonths(hod);

            this.setupChart();
          } else {
            console.log("Something went wrong.");
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    },
  },
};
</script>

<style>
.dp__input {
  width: 150px;
  text-align: center;
}
</style>
